import { Filter, FilterConfig, FilterTypes, IsFilterable } from "@/lib/filterable";
import { MrfiktivReferenceGen } from "@/services/mrfiktiv/v1/data-contracts";
import { BackendResourceEnum } from "@/store/enum/authResourceEnum";

@IsFilterable
class VehicleReferenceEntity implements MrfiktivReferenceGen {
  @FilterConfig({
    displayName: "common.nouns.vehicle",
    type: FilterTypes.OBJECT_ID,
    config: {
      // eslint-disable-next-line @typescript-eslint/no-var-requires
      itemCallback: () => require("@/store/modules/access-layers/vehicle.access-layer").VehicleAccessLayer.entities,
      mapItemToComponent: (item) => ({ item }),
      itemValue: "id",
      component: "refs-vehicle",
      refType: BackendResourceEnum.VEHICLE
    }
  })
  refId: string;

  refType: BackendResourceEnum;

  constructor(sharedContent?: Partial<IVehicleReferenceEntity>) {
    this.refId = sharedContent?.refId || "";
    this.refType = sharedContent?.refType as BackendResourceEnum;
  }
}
type IVehicleReferenceEntity = VehicleReferenceEntity;
const VehicleReference = Filter.createForClass(VehicleReferenceEntity);

export { IVehicleReferenceEntity, VehicleReference };
